import { createUseStyles } from 'react-jss';

import { Gradients } from '@picsart/design-system/foundation/gradients';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontSizes } from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { AbsoluteWhiteColors } from '@picsart/design-system/foundation/colors';
import { Effects } from '@picsart/design-system/foundation/effects';

const useStyles = createUseStyles(
  {
    actionBar: {
      position: 'relative',
    },
    uploadButton: {
      height: Spacings.s48,
      borderRadius: CornerRadius.r24,
      background: Gradients.pro,
      color: AbsoluteWhiteColors.base.default,
    },
    creditsChip: {
      position: 'absolute',
      right: Spacings.s8,
      top: '50%',
      transform: 'translateY(-50%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: Spacings.s4,
      height: Spacings.s32,
      padding: `0 ${Spacings.s12}`,
      borderRadius: CornerRadius.r32,
      backgroundColor: Effects.alpha20,
      color: AbsoluteWhiteColors.base.default,
      fontSize: FontSizes.t4,
      fontWeight: FontWeights.medium,
      pointerEvents: 'none',
    },
    creditsIcon: {
      width: Spacings.s16,
      height: Spacings.s16,
    },
    creditsSpinner: {
      display: 'inline-block',
    },
  },
  { name: 'feed-action-bar' }
);

export default useStyles;
